// Republic Atlas - Main App Component

import { useEffect } from 'react';
import { QueryProvider } from '@/providers/QueryProvider';
import { AuthProvider } from '@/providers/AuthProvider';
import { AppRouter } from '@/router';
import { DebugPanel } from '@/components/dev/DebugPanel';
import { Toaster } from '@/components/ui';
import './App.css';

function App() {
  // Force dark mode on mount with Polymarket-inspired background
  useEffect(() => {
    document.documentElement.classList.add('dark');
    document.body.style.backgroundColor = '#0a0e27';
  }, []);

  return (
    <div className="dark min-h-screen bg-background text-white antialiased">
      <QueryProvider>
        <AuthProvider>
          <AppRouter />
          <DebugPanel />
          <Toaster />
        </AuthProvider>
      </QueryProvider>
    </div>
  );
}

export default App;

